<script setup lang="ts">
  import { BackButton } from '@/shared/ui/components'

  import DepartmentsCreate from '@/views/admin/departments/Create.vue'

  const route = useRoute('/admin/departments/new')
  const parentId = route.query.parentId as string
  definePage({
    meta: {
      layout: 'admin',
    },
  })
</script>

<template>
  <div class="head">
    <div class="content">
      <div class="flex items-center gap-4">
        <BackButton
          type="rounded"
          :route="{ name: '/admin/departments/' }"
          strict-route
        />
        <h2>{{ $t('admin_departments_create_department') }}</h2>
      </div>
    </div>
  </div>
  <div class="content mt-5">
    <DepartmentsCreate :parent-id="parentId" />
  </div>
</template>

<style>
  .uselect button {
    min-height: 34px;
  }
</style>
